import React from 'react'
import HttpServices from '../../../utils/Http.services'
import { checkTextTranslation, imageAddress, translate } from '../../../utils/useful'


class ThirdStep extends React.Component {
    state = {
        imageSlide: [

            { img: '/assets/images/BingWallpaper.jpg', name: "Widgets-1", size: 'small' },
            { img: '/assets/images/BingWallpaper.jpg', name: "Widgets-2", size: 'medium' },
            { img: '/assets/images/BingWallpaper.jpg', name: "Widgets-3", size: 'large' },

        ],
        widgetitem: []
    }

    // componentDidMount() {
    //     // this.getAllApplets()
    //     console.log("LOGG")
    //     let widget = this.props.initData?.widget.images
    //     console.log('applet', widget)
    //     this.setState({ widget: widget })

    // }

    nextPage = (item) => {
        this.props.setData(({ widgetKey: item.key }), () => {
            // this.props.setData(({ applet: item }) => {

            this.props.changeStage('fourthstep')

        })

    }

    render() {
        return (
            <div width={this.props.width} className="w-100 h-100 scroll-no-scrollbar">

                <div className="px-2 w-100 py-2 position-sticky top-0" style={{ background: 'linear-gradient(to right , #4685cccb,#4646cc)', backgroundColor: '#4646cc' }}>
                    <div className="">

                        <button onClick={() => this.props.lastStage()} className='flexc'>
                            <div className='rotate-180 br-50 ws-25 hs-25 flexcc' style={{ background: '#ffffffcd' }}>
                                <img className='' src="/assets/icons/useful/angle-right.svg" height={20} />
                            </div>
                            <h2 style={{ color: '#ffffffcc', fontSize: 19 }} className="  mx-2" >{translate('Select Widgets')}</h2>
                        </button>
                    </div>
                    {/* <div >
                                            <div style={{ backgroundColor: '#f6f6f6', borderRadius: 6 }}>
                                                <input className="py-1 px-2 w-100" placeholder={translate('Search ...')} style={{ backgroundColor: 'transparent', border: 'none' }} />
                                            </div>
                                        </div> */}
                </div>
                {console.log(this.props.initData?.widget.types)}
                <div className="w-100 mt-3 ">
                    {Object.values(this.props.initData?.widget.types).map((prop) => {
                        return (
                            <div className="flexcc mb-4" style={{ cursor: 'pointer' }} onClick={() => this.nextPage(prop)}>
                                {/* <div className="flexcc mb-4" style={{ cursor: 'pointer' }} onClick={() => this.props.changeStage('fourthstep')}> */}
                                <div>
                                    <div>
                                        <img src={prop.img} style={{ borderRadius: 11 }} width='200px' />
                                    </div>
                                    <div className="flexcc flex-column">
                                        <div>
                                            <p style={{ fontSize: 14 }}>{prop.name}</p>
                                        </div>
                                        <div>
                                            <p style={{ fontSize: 11 }}>{prop.size}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>

            </div>

        );
    }
}

export default ThirdStep;